import { apiRequest } from '@/utils/api-request';
import { Eval } from '@/types/evals-types';
import { useOrgStore } from '@/stores/org-store';

export const updateEvaluation = async (
  evalId: string,
  body: Eval,
): Promise<Eval> => {
  const orgId = useOrgStore.getState().currentOrg?.orgid;
  const response = await apiRequest<Eval>({
    url: `/evaluations/${orgId}/${evalId}`,
    target: 'platform',
    method: 'PUT',
    body: body as unknown as Record<string, unknown>,
  });

  if (response.success === false) {
    throw new Error(response.detail);
  }

  return response?.data as Eval;
};
